import { createRoot } from "react-dom/client";
import { PopupAlert } from "../atoms/PopupAlert";

const body = document.querySelector("body");
const confirmRoot = document.createElement("div");
body?.appendChild(confirmRoot);

interface Props {
  text: string;
  title?: string;
  options?: {
    trueButtonText?: string;
    falseButtonText?: string;
  };
}

interface ConfirmDialogProps {
  text: string;
  title?: string;
  options?: {
    trueButtonText?: string;
    falseButtonText?: string;
  };
  giveAnswer: (answer: boolean) => void;
}

function ConfirmDialog({
  text,
  title,
  options,
  giveAnswer,
}: ConfirmDialogProps) {
  return (
    <PopupAlert
      title={title ?? "알림"}
      text={text}
      buttons={
        <>
          <button
            type="button"
            className="confirm_btn"
            onClick={() => giveAnswer(true)}
            autoFocus
          >
            {options?.trueButtonText ? options?.trueButtonText : "확인"}
          </button>
          <button
            type="button"
            className="cancel_btn"
            onClick={() => giveAnswer(false)}
          >
            {options?.falseButtonText ? options?.falseButtonText : "취소"}
          </button>
        </>
      }
    />
  );
}

export const confirmDialog = ({
  text,
  title,
  options,
}: Props): Promise<boolean> =>
  new Promise((res) => {
    const root = createRoot(confirmRoot);

    const giveAnswer = (answer: boolean) => {
      root.unmount();
      res(answer);
    };

    root.render(
      <ConfirmDialog
        title={title}
        text={text}
        giveAnswer={giveAnswer}
        options={options}
      />
    );
  });
